import React, { useCallback, useEffect, useState } from "react";
import "./../Form.scss";
import "./PedidosForm.scss";
import { useHistory, useParams } from "react-router";
import service from "../../../services/pedidos";
import serviceCatalogos from "../../../services/catalogos";
import serviceProdutos from "../../../services/produtos";
import serviceUsuarios from "../../../services/usuarios";
import serviceCampanhas from "../../../services/campanhas";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faPlus, faPrint, faTrash } from "@fortawesome/free-solid-svg-icons";
import { hasText, isDate, maskDate } from "../../../utils/utils";
import { actions as actionsSite } from "../../../redux/actions/site";
import { useDispatch, useSelector } from "react-redux";
import { date2Front, datetime2Front } from "../../../utils/converts";
import { currencyToFloat, formatCurrency } from "../../../utils/Money";
import { getSituacao } from "./Pedidos";
import CheckBox from "../form/generics/CheckBox";
import { generatePdf } from "./pdf/createPdf";

const PedidosView = (props) => {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.auth.profile);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const params = useParams();
  const [produtos, setProdutos] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [catalogos, setCatalogos] = useState([]);
  const [pedido, setPedido] = useState({});
  const [itemPedidos, setItemPedidos] = useState([]);
  const [campanhas, setCampanhas] = useState([]);
  const [datasVencimento, setDatasVencimento] = useState([{ data: "" }, { data: "" }, { data: "" }, { data: "" }, { data: "" }, { data: "" }]);

  const { register, handleSubmit, setValue, errors, getValues, setError } = useForm();

  const rota = props.compra ? "pedidos-compra" : "pedidos-venda";


  const carregarPedido = useCallback(async (id) => {
    const pedidoInicial = await service.getById(id);
    setPedido(pedidoInicial);
    
    setDatasVencimento(pedidoInicial.vencimentos);
    // console.log(_datasVencimento,'<<_datasVencimento');
    setItemPedidos(pedidoInicial.items);
    setLoading(false);
  }, []);

  useEffect(() => {
    const run = async () => {
      // const _catalogos = serviceCatalogos.get(`?catalogo=NULL&sort=nome&active=true`);
      const _produtos = serviceProdutos.get(`?active=true`);
      const _usuarios = serviceUsuarios.get(`?active=true&sort=nome`);
      const _campanhas = serviceCampanhas.get(`?active=true&sort=dataInicio`);
      const [_resProdutos, _resUsuarios, _resCampanhas] = await Promise.all([_produtos, _usuarios, _campanhas]);
      if (props.compra) {
        _resProdutos.rows = _resProdutos.rows.map((produto) => {
          produto.valor -= (produto.valor * 30) / 100;
          return produto;
        });
      }
      setProdutos(_resProdutos.rows);
      // setCatalogos(_resCatalogos.rows);
      // setUsuarios(_resUsuarios.rows);
      setCampanhas(_resCampanhas.rows);
      if (params.id) {
        carregarPedido(params.id);
      } else {
        setLoading(false);
      }
    };
    run();
  }, [carregarPedido, params.id]);


  const getCatalogo = (id) => {
    const obj = catalogos.find((e) => e._id === id);
    return obj;
  };

  

  const renderItensPedidos = () => {
    return (
      <table cellPadding="0" cellSpacing="0" className="itensPedido">
        <thead>
          <tr>
            <th width="150">Código Produto</th>
            <th width="80">Qtd.</th>
            <th>Descrição</th>
            <th width="150">Valor Unit.</th>
            <th width="150">Valor Total</th>
          </tr>
        </thead>
        <tbody>
          {itemPedidos.map((e, index) => (
            <tr key={index}>
              <td>{e.produto.codigo}</td>
              <td>{e.quantidade}</td>
              <td>{e.produto.nome}</td>
              <td>{formatCurrency(e.valor)}</td>
              <td>{formatCurrency(e.valor * e.quantidade)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <th colSpan={4} className="total" align="right" style={{ paddingRight: 30 }}>
              TOTAL
            </th>
            <th align="left">{getTotalValorBruto()}</th>
          </tr>
        </tfoot>
      </table>
    );
  };

  const getTotalValorBruto = () => {
    let valor = 0;
    itemPedidos.map((a) => (valor += a.valor * a.quantidade));
    return formatCurrency(valor);
  };

  const getTotalValorLiquido = () => {
    let valor = 0;
    itemPedidos.map((a) => (valor += (a.valor - (a.valor * a.desconto) / 100) * a.quantidade));
    return formatCurrency(valor);
  };

  const getTotalValorLiquidoParcelas = () => {
    const valor = currencyToFloat(getTotalValorLiquido());
    const tarifaParcela = currencyToFloat(getValues("tarifaParcela")) || 0;
    const numeroParcelas = parseInt(getValues("numeroParcelas") || 1);
    const valorParcela = (valor / numeroParcelas + tarifaParcela).toFixed(2);
    setValue("valorParcela", formatCurrency(valorParcela));
    return formatCurrency(valorParcela);
  };

  const getTotalPontos = () => {
    let valor = 0;
    itemPedidos.map((a) => (valor += a.produto.pontos * a.quantidade));
    return formatCurrency(valor);
  };

  const renderItensPedidosVenda = () => {
    return (
      <table cellPadding="0" cellSpacing="0" className="itensPedido">
        <thead>
          <tr>
            <th width="100">Cód. Prod.</th>
            <th width="80">Qtd.</th>
            <th>Descrição</th>
            <th width="100">Valor Bruto</th>
            <th width="100">Desc. %</th>
            <th width="100">Valor Líq.</th>
            <th width="100">Pontos</th>
          </tr>
        </thead>
        <tbody>
          {itemPedidos.map((e, index) => {
            return (
              <tr key={index}>
                <td>{e.produto.codigo}</td>
                <td>{e.quantidade}</td>
                <td>{e.produto.nome}</td>
                <td>{formatCurrency(e.valor * e.quantidade)}</td>
                <td>{formatCurrency(e.desconto)}</td>
                <td>{formatCurrency((e.valor - (e.valor * e.desconto) / 100) * e.quantidade)}</td>
                <td>{formatCurrency(e.produto.pontos * e.quantidade)}</td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <th colSpan={3} align="right" style={{ paddingRight: 30 }}>
              TOTAL
            </th>
            <th align="left">{getTotalValorBruto()}</th>
            <th align="left"></th>
            <th align="left">{getTotalValorLiquido()}</th>
            <th align="left">{getTotalPontos()}</th>
          </tr>
        </tfoot>
      </table>
    );
  };

  const changeValueMoney = (value, args) => {
    const campo = args.campo + args.index;
    const newValue = formatCurrency(value);
    setValue(campo, newValue);
    document.querySelector("#" + args.campo + args.index).classList.add("hasText");
  };


  const resetItemPedidos = () => {
    const _itemPedidos = [...itemPedidos];
    setItemPedidos(_itemPedidos);
  };

  const addBreak = () => {
    return <div className="break"></div>;
  };

  const isParcelado = () => {
    if (pedido.tipoPagamento) {
      return pedido.tipoPagamento.indexOf("Prazo") !== -1 || pedido.tipoPagamento.indexOf("Parcelado") !== -1;
    }
    return false;
  };

  const isParceladoCampanha = () => {
    if (pedido.tipoPagamento) {
      return pedido.tipoPagamento.indexOf("Campanha") !== -1;
    }
    return false;
  };

  const isParceladoBoletoDinheiro = () => {
    if (pedido.tipoPagamento) {
      return pedido.tipoPagamento.indexOf("Boleto") !== -1 || pedido.tipoPagamento.indexOf("Dinheiro") !== -1;
    }
    return false;
  };

  const isParceladoCartao = () => {
    if (pedido.tipoPagamento) {
      return pedido.tipoPagamento.indexOf("Parcelado") !== -1;
    }
    return false;
  };

  const setCampanhaVencimento = (codigo, checked) => {
    const _pedido = { ...pedido };
    if (_pedido.campanhasPagamento.includes(codigo)) {
      const index = _pedido.campanhasPagamento.indexOf(codigo);
      _pedido.campanhasPagamento.splice(index, 1);
    } else {
      _pedido.campanhasPagamento.push(codigo);
    }
    setValue("numeroParcelas", _pedido.campanhasPagamento.length);
    _pedido.numeroParcelas = _pedido.campanhasPagamento.length;
    setPedido(_pedido);
  };

  const setDescontoProdutos = (value) => {
    const _itemPedidos = [...itemPedidos];
    for (let x = 0; x < _itemPedidos.length; x++) {
      const item = _itemPedidos[x];
      item.desconto = currencyToFloat(value);
      const campo = "desconto" + x;
      setValue(campo, value);
      if (document.querySelector("#desconto" + x)) {
        document.querySelector("#desconto" + x).classList.add("hasText");
      }
    }
    resetItemPedidos();
  };

  const parcelasIsReadonly = () => {
    return !isParceladoCartao();
  };



  return (
    <>
      {!loading && (
        <div className="form pedidos">
          <form onSubmit={()=>false} className="formModule branco pedidosForm">
            <div className="acoes">
              <button type="button" className="print" onClick={() => { generatePdf(pedido) }}>
                <FontAwesomeIcon icon={faPrint} /> Imprimir
              </button>
              <button type="button" className="cancelar" onClick={() => history.push("/painel/" + rota)}>
                <FontAwesomeIcon icon={faBan} /> Voltar
              </button>
            </div>
            <div className="break"></div>

            <div className="field">
              <input className={"hasText"} defaultValue={pedido.sequencia} type="text" readOnly />
              <label>Nº</label>
            </div>
            <div className="field">
              <input className={"hasText"} defaultValue={getSituacao(pedido)} type="text" readOnly />
              <label>Situação</label>
            </div>
            <div className="field">
              <input className={"hasText"} defaultValue={datetime2Front(pedido.createAt)} type="text" readOnly />
              <label htmlFor="createAt">Data</label>
            </div>
            {addBreak()}

            <div className="field">
              <input className={"hasText"} defaultValue={pedido.catalogo.nome} type="text" readOnly />
              <label htmlFor="catalogo">Catálogo</label>
            </div>
            {!props.compra && (
              <div className={errors.usuario ? "field error" : "field"}>
                <input className={"hasText"} defaultValue={pedido.usuario?.nome ?? ""} type="text" readOnly />
                {/* <select name="usuario" className="hasText" ref={register({ required: true })} id="usuario" value={pedido.usuario || ""} onChange={(e) => changeUsuario(e)}>
                  {optionUsuarios()}
                </select> */}
                <label htmlFor="usuario">Revendedora</label>
              </div>
            )}

            {props.compra && (
              <>
                <div className="field">
                  <input className={"hasText"} defaultValue={pedido.tipoPagamento} type="text" readOnly />
                  <label htmlFor="tipoPagamento">Pagamento</label>
                </div>

                <div className="field">
                  <input className={"hasText"} defaultValue={pedido.numeroNf} type="text" readOnly />
                  <label htmlFor="numeroNf">NF</label>
                </div>

                <div className="field">
                  <input className={"hasText"} defaultValue={pedido.numeroParcelas} type="text" readOnly />
                  <label htmlFor="numeroParcelas">Parcelas</label>
                </div>

                <div className="field">
                  <input className={"hasText"} defaultValue={date2Front(pedido.dataEntrega)} type="text" readOnly />
                  <label htmlFor="dataEntrega">Data da entrega</label>
                </div>
              </>
            )}

            <div className="break"></div>
            <h3 className="tituloEtapa mt20">Itens</h3>
            <div className="break"></div>
            {/* {!params.id && renderFormItemPedidos()} */}
            {/* {params.id && props.compra && renderItensPedidos()} */}
            {/* {params.id && !props.compra && getSituacao(pedido) === 'Pendente' && renderFormItensPedidosVenda()} */}
            {/* {params.id && !props.compra && getSituacao(pedido) !== 'Pendente' && renderItensPedidosVenda()} */}
            {!props.compra && renderItensPedidosVenda()}
            {props.compra && renderItensPedidos()}

            {addBreak()}
            {!props.compra && params.id && (
              <>
                <div className={errors.desconto ? "field error" : "field"}>
                  <input
                    className={"hasText"}
                    name="desconto"
                    id="desconto"
                    defaultValue={formatCurrency(pedido.desconto)}
                    onChange={(e) => {
                      changeValueMoney(e.target.value, { index: "", campo: "desconto" });
                    }}
                    onKeyUp={(e) => hasText(e)}
                    type="text"
                    onBlur={(e) => setDescontoProdutos(e.target.value)}
                    maxLength={5}
                    ref={register()}
                    //readOnly
                  />
                  <label htmlFor="desconto">Desconto %</label>
                </div>
                <div className={errors.tipoPagamento ? "field error" : "field"}>
                  <input className={"hasText"} defaultValue={pedido.tipoPagamento || ""} type="text" readOnly />
                  <label htmlFor="tipoPagamento">Pagamento</label>
                </div>
                <div className={errors.valorFrete ? "field error" : "field"}>
                  <input
                    className={"hasText"}
                    name="valorFrete"
                    id="valorFrete"
                    defaultValue={formatCurrency(pedido.valorFrete)}
                    onChange={(e) => {
                      changeValueMoney(e.target.value, { index: "", campo: "valorFrete" });
                    }}
                    type="text"
                    ref={register()}
                    //readOnly
                  />
                  <label htmlFor="valorFrete">Valor Frete (cobrado na 1ª parcela)</label>
                </div>

                {isParcelado() && (
                  <>
                    {addBreak()}
                    <div className={errors.tarifaParcela ? "field error" : "field"}>
                      <input
                        className={"hasText"}
                        name="tarifaParcela"
                        id="tarifaParcela"
                        defaultValue={formatCurrency(pedido.tarifaParcela)}
                        onChange={(e) => {
                          changeValueMoney(e.target.value, { index: "", campo: "tarifaParcela" });
                          getTotalValorLiquidoParcelas();
                        }}
                        onKeyUp={(e) => hasText(e)}
                        type="text"
                        ref={register()}
                        //readOnly
                      />
                      <label htmlFor="tarifaParcela">Tarifa por parcela</label>
                    </div>
                    <div className={errors.numeroParcelas ? "field error" : "field"}>
                      <input
                        className={pedido.numeroParcelas ? "hasText" : ""}
                        name="numeroParcelas"
                        id="numeroParcelas"
                        defaultValue={pedido.numeroParcelas}
                        onKeyUp={(e) => hasText(e)}
                        type="text"
                        onChange={() => {
                          getTotalValorLiquidoParcelas();
                        }}
                        ref={register({ validate: { isNumeric: (value) => !isNaN(value) } })}
                        readOnly={parcelasIsReadonly()}
                      />
                      <label htmlFor="numeroParcelas">Parcelas</label>
                    </div>
                    <div className={"field"}>
                      <input
                        className={"hasText"}
                        name="valorParcela"
                        id="valorParcela"
                        defaultValue={getTotalValorLiquidoParcelas()}
                        onKeyUp={(e) => hasText(e)}
                        type="text"
                        ref={register()}
                        readOnly
                      />
                      <label htmlFor="numeroParcelas">Valor por parcela</label>
                    </div>
                    {isParceladoCampanha() && (
                      <>
                        {addBreak()}
                        <h3 className="tituloEtapa mt20">Escolha as campanhas</h3>
                        {addBreak()}
                        {campanhas.map((campanha, index) => {
                          return (
                            <CheckBox key={index} label={campanha.codigo} value={campanha.codigo} callback={setCampanhaVencimento} checked={pedido.campanhasPagamento.includes(campanha.codigo)} />
                          );
                        })}
                      </>
                    )}
                    {isParceladoBoletoDinheiro() && (
                      <>
                        {addBreak()}
                        <h3 className="tituloEtapa mt20">Escolha as datas de vencimento</h3>
                        {addBreak()}
                        {datasVencimento.map((obj, index) => {
                          return (
                            <React.Fragment key={index}>
                              <div className={errors["dataVencimento" + index] ? "field error" : "field"}>
                                <input
                                  name={`dataVencimento${index}`}
                                  id={`dataVencimento${index}`}
                                  maxLength={10}
                                  className={"hasText"}
                                  readOnly
                                  type="text"
                                  defaultValue={obj.data}
                                  ref={register({ validate: { isDate: (value) => isDate(value) } })}
                                />
                                <label htmlFor={`dataVencimento${index}`}>Data de Vencimento {index + 1}</label>
                              </div>
                              {index === 2 && addBreak()}
                            </React.Fragment>
                          );
                        })}
                      </>
                    )}
                  </>
                )}
              </>
            )}
            {addBreak()}
            <h3 className="tituloEtapa mt20">Outras informações</h3>
            {addBreak()}
            <div className="field">
              <input className={"hasText"} defaultValue={pedido.obs} type="text" readOnly />
              <label htmlFor="obs">Observações</label>
            </div>

            <div className="break mt20"></div>
            <div className="acoes">
              <button type="button" className="print" onClick={() => { generatePdf(pedido) }}>
                <FontAwesomeIcon icon={faPrint} /> Imprimir
              </button>
              <button type="button" className="cancelar" onClick={() => history.push("/painel/" + rota)}>
                <FontAwesomeIcon icon={faBan} /> Voltar
              </button>
            </div>
          </form>
        </div>
      )}
      {loading && "Carregando..."}
    </>
  );
};

export default PedidosView;
